import React from 'react';
import { Box, FieldTypes, Inscription, Option } from '@common-fe/common-fe';

import { IBillingMethodTypePropertyDtoBillingMethodTypeEnum } from '@/types';

import { useEmployerReactivationAccountUsage } from './hooks/useEmployerReactivationAccountUsage';
import { EmployerReactivationAccountUsageField } from './EmployerReactivationAccountUsageField';

interface Props {
  options: Option[];
  hasFieldErrors?: boolean;
}

export const EmployerReactivationAccountUsage: React.FC<Props> = ({ options, hasFieldErrors }) => {
  const { payrollValue, fundingValue, handlePayrollChange, handleFundingChange } = useEmployerReactivationAccountUsage();

  return (
    <Box
      margin={{ top: 'spacing24' }}
      pad="spacing24"
      round="container1Round"
      background={{ color: 'canvas' }}
      border={{ size: '1px', color: 'border2' }}
    >
      <Box>
        <Inscription margin={{ bottom: 'spacing16' }}>
          Usage for bank account(s):
        </Inscription>
      </Box>

      <EmployerReactivationAccountUsageField
        title='Payroll contribution'
        description='Elevate collects funds for any contribution based account prior to posting to the employees account'
        placeholder='Select bank account'
        fieldType={FieldTypes.Dropdown}
        methodType={IBillingMethodTypePropertyDtoBillingMethodTypeEnum.PULL_FUNDS}
        testId='EmployerReactivationAccountUsage_payroll_contribution'
        options={options}
        value={payrollValue}
        onChange={handlePayrollChange}
        isRequired
        hasError={hasFieldErrors && !payrollValue}
      />

      <Box
        width="100%"
        height="1px"
        background={{ color: 'border1' }}
        margin={{ vertical: 'spacing16'}}
      />

      <EmployerReactivationAccountUsageField
        title='Funding replenishment'
        description='Funds collected to replenish the plans account after claim payment have been made'
        placeholder='Select bank account'
        fieldType={FieldTypes.Dropdown}
        methodType={IBillingMethodTypePropertyDtoBillingMethodTypeEnum.PUSH_FUNDS}
        testId='EmployerReactivationAccountUsage_funding_replenishment'
        options={options}
        value={fundingValue}
        onChange={handleFundingChange}
        isRequired
        hasError={hasFieldErrors && !fundingValue}
      />
    </Box>
  );
};
